import { render } from "./CredentialsForm.vue?vue&type=template&id=373153de&scoped=true"
import script from "./CredentialsForm.vue?vue&type=script&lang=js"
export * from "./CredentialsForm.vue?vue&type=script&lang=js"

import "./CredentialsForm.vue?vue&type=style&index=0&id=373153de&lang=scss&scoped=true"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-373153de"]])

export default __exports__